import { CREDIT_CARD_TYPE } from "@icoach/constants/";
import { Icons } from "@curves/ui-base";
/** @typedef {'OWNER' | 'OTHER' | 'DELEGATED'} SignType */
/**
 * @type {Record<SignType, number>}
 * @description 信用卡使用者類型定義：
 * - 1: OWNER — 本人使用信用卡。
 * - 2: OTHER — 非本人使用，且未經授權。
 * - 3: DELEGATED — 非本人使用，但持卡人已授權（例如在場同意）。
 * 僅前端使用
 */
const SIGNTYPE = {
	OWNER: 1, // 本人
	OTHER: 2, // 非本人且未授權
	DELEGATED: 3, // 授權他人使用
};

const OWNERTEXT = "本人";

const CARDFIELDMAP = {
	CARDNO: "creditCardNo",
	EXPIRYDATE: "cardExpiryDate",
	BANKNAME: "creditCardBankName",
	OWNER: "cardName",
	CARDTYPE: "creditCardType",
};

const CREDIT_CARD_TYPE_ICON = {
	[CREDIT_CARD_TYPE.VISA]: Icons.VISA,
	[CREDIT_CARD_TYPE.MasterCard]: Icons.Mastercard,
	[CREDIT_CARD_TYPE.OTHER]: Icons.CrediCard,
	[CREDIT_CARD_TYPE.JCB]: Icons.JCB,
};

const SENSITIVE_FIELDS = [CARDFIELDMAP.CARDNO, CARDFIELDMAP.EXPIRYDATE, CARDFIELDMAP.CARDTYPE];

export { SIGNTYPE, OWNERTEXT, SENSITIVE_FIELDS, CARDFIELDMAP, CREDIT_CARD_TYPE_ICON };
